"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvisorEmbeddedAdPlacements = exports.AdPlacement = exports.AdTag = exports.AdNameAttributeRecord = exports.AdName = exports.AdMediaType = exports.AdAspectRatio = exports.FULL_HEIGHT_SENTINEL = exports.FULL_WIDTH_SENTINEL = exports.AdHostPlatform = void 0;
var AdHostPlatform;
(function (AdHostPlatform) {
    AdHostPlatform["Vimeo"] = "Vimeo";
    AdHostPlatform["YouTube"] = "YouTube";
    AdHostPlatform["AvenFinancial"] = "AvenFinancial";
})(AdHostPlatform || (exports.AdHostPlatform = AdHostPlatform = {}));
// for ads that are full width, they're stored in the DB with this sentinel as pxWidth
exports.FULL_WIDTH_SENTINEL = -1;
// for ads that are full height, they're stored in the DB with this sentinel as pxHeight
exports.FULL_HEIGHT_SENTINEL = -1;
var AdAspectRatio;
(function (AdAspectRatio) {
    AdAspectRatio["Square"] = "Square";
    AdAspectRatio["Landscape_117_100"] = "Landscape_117_100";
    AdAspectRatio["Landscape_16_9"] = "Landscape_16_9";
    AdAspectRatio["Landscape_4_3"] = "Landscape_4_3";
    AdAspectRatio["Portrait_9_16"] = "Portrait_9_16";
    AdAspectRatio["Portrait_3_4"] = "Portrait_3_4";
    AdAspectRatio["NotApplicable"] = "NotApplicable";
})(AdAspectRatio || (exports.AdAspectRatio = AdAspectRatio = {}));
var AdMediaType;
(function (AdMediaType) {
    AdMediaType["Video"] = "Video";
    AdMediaType["Image"] = "Image";
})(AdMediaType || (exports.AdMediaType = AdMediaType = {}));
var AdName;
(function (AdName) {
    /** Rewards-to-Home-only (not Flex). Named "ucc" for backcompat. */
    AdName["uccBalanceTransferTeaserPreExpirationAug2025"] = "uccBalanceTransferTeaserPreExpirationAug2025";
    /** Rewards-to-Home-only (not Flex). Named "ucc" for backcompat. */
    AdName["uccBalanceTransferTeaserPostExpirationAug2025"] = "uccBalanceTransferTeaserPostExpirationAug2025";
    AdName["balanceDetailsBeardSep2025"] = "balanceDetailsBeardSep2025";
    AdName["creditCardBalanceTransferAug2025"] = "creditCardBalanceTransferAug2025";
    AdName["personalLoanRefiAug2025"] = "personalLoanRefiAug2025";
    AdName["genericAvenCashAug2025"] = "genericAvenCashAug2025";
    AdName["genericMoapAug2025"] = "genericMoapAug2025";
    AdName["genericMoapVideoInterstitialAug2025"] = "genericMoapVideoInterstitialAug2025";
    AdName["uccMoapStarbucksFiftyDollarCreditAug2025"] = "uccMoapStarbucksFiftyDollarCreditAug2025";
    AdName["dryrunHelocRefiNov2025"] = "dryrunHelocRefiNov2025";
    AdName["dryrunMoapAug2025"] = "dryrunMoapAug2025";
    AdName["homeEquityFocusDryrunMoapAug2025"] = "homeEquityFocusDryrunMoapAug2025";
    AdName["postFlexCashOutDryrunMoapSep2025"] = "postFlexCashOutDryrunMoapSep2025";
    AdName["flexToHomeActivityDryrunMoapFeb2026"] = "flexToHomeActivityDryrunMoapFeb2026";
    AdName["flexToHomePlTransferDryrunMoapMar2026"] = "flexToHomePlTransferDryrunMoapMar2026";
    AdName["mortgageRefiAug2025"] = "mortgageRefiAug2025";
    AdName["signNowMoapAug2025"] = "signNowMoapAug2025";
    AdName["getMoneyAug2025"] = "getMoneyAug2025";
    AdName["getMoneyWithOneYearOfStarbucksOct2025"] = "getMoneyWithOneYearOfStarbucksOct2025";
    AdName["genericStarbucksMoapAug2025"] = "genericStarbucksMoapAug2025";
    AdName["uccMoapStarbucksAug2025"] = "uccMoapStarbucksAug2025";
    AdName["uccFlexLargePurchaseAdviceAug2025"] = "uccFlexLargePurchaseAdviceAug2025";
    AdName["helocRefiGuaranteedBeatOct2025"] = "helocRefiGuaranteedBeatOct2025";
    /** Rewards-to-Home-only (not Flex). Named "ucc" for backcompat. */
    AdName["uccToHomeGuaranteedAprBeatJan2026"] = "uccToHomeGuaranteedAprBeatJan2026";
    /** Rewards-to-Home-only (not Flex). Named "ucc" for backcompat. */
    AdName["uccToHomeActivityCardCarouselJan2026"] = "uccToHomeActivityCardCarouselJan2026";
    /** Rewards-to-Home-only (not Flex). Named "ucc" for backcompat. */
    AdName["uccToHomeCashBackSideBySideAug2026"] = "uccToHomeCashBackSideBySideAug2026";
    AdName["boostNetWorthDec2025"] = "boostNetWorthDec2025";
    AdName["flexToHomeInterestSavedUpgradeFeb2026"] = "flexToHomeInterestSavedUpgradeFeb2026";
    AdName["advisorGenericDepositFeb2026"] = "advisorGenericDepositFeb2026";
    AdName["homeDeniedDepositMar2026"] = "homeDeniedDepositMar2026";
    AdName["rewardsBtUpsellBalanceDetailsBeardSep2026"] = "rewardsBtUpsellBalanceDetailsBeardSep2026";
    AdName["rewardsBtUpsellInAppAug2026"] = "rewardsBtUpsellInAppAug2026";
    AdName["rewardsDepositBundleUpsellSep2026"] = "rewardsDepositBundleUpsellSep2026";
    AdName["faqVideoHowDoesTheAvenHomeEquityCardWork"] = "faqVideoHowDoesTheAvenHomeEquityCardWork";
    AdName["faqVideoIDontReallyNeedTheExtraMoney"] = "faqVideoIDontReallyNeedTheExtraMoney";
    AdName["faqVideoIDontWantALienOnMyHouse"] = "faqVideoIDontWantALienOnMyHouse";
    AdName["faqVideoHowDoPaymentsWork"] = "faqVideoHowDoPaymentsWork";
    AdName["faqVideoChargedInterestIfIPayMyFullBalance"] = "faqVideoChargedInterestIfIPayMyFullBalance";
    AdName["faqVideoWhyShouldIGetTheAvenHomeEquityCard"] = "faqVideoWhyShouldIGetTheAvenHomeEquityCard";
    AdName["faqVideoIsTheRewardsCardASecondCard"] = "faqVideoIsTheRewardsCardASecondCard";
    AdName["faqVideoWhatsTheDifferenceBetweenHomeAndRewards"] = "faqVideoWhatsTheDifferenceBetweenHomeAndRewards";
    AdName["faqVideoIsTheAvenCardALoanOrALineOfCredit"] = "faqVideoIsTheAvenCardALoanOrALineOfCredit";
    AdName["faqVideoWhichProductIsBetter"] = "faqVideoWhichProductIsBetter";
})(AdName || (exports.AdName = AdName = {}));
const VideoWithFootnoteAdNameAttributes = {
    hasVideoFootnotes: true,
    isUpgradeCard: false,
    isCycledAd: false,
};
const CycledUpgradeCardAdNameAttributes = {
    hasVideoFootnotes: false,
    isUpgradeCard: true,
    isCycledAd: true,
};
const NonCycledUpgradeCardAdNameAttributes = {
    hasVideoFootnotes: false,
    isUpgradeCard: true,
    isCycledAd: false,
};
exports.AdNameAttributeRecord = {
    [AdName.faqVideoHowDoesTheAvenHomeEquityCardWork]: VideoWithFootnoteAdNameAttributes,
    [AdName.faqVideoIDontReallyNeedTheExtraMoney]: VideoWithFootnoteAdNameAttributes,
    [AdName.faqVideoIDontWantALienOnMyHouse]: VideoWithFootnoteAdNameAttributes,
    [AdName.faqVideoHowDoPaymentsWork]: VideoWithFootnoteAdNameAttributes,
    [AdName.faqVideoChargedInterestIfIPayMyFullBalance]: VideoWithFootnoteAdNameAttributes,
    [AdName.faqVideoWhyShouldIGetTheAvenHomeEquityCard]: VideoWithFootnoteAdNameAttributes,
    [AdName.faqVideoIsTheRewardsCardASecondCard]: VideoWithFootnoteAdNameAttributes,
    [AdName.faqVideoWhatsTheDifferenceBetweenHomeAndRewards]: VideoWithFootnoteAdNameAttributes,
    [AdName.faqVideoIsTheAvenCardALoanOrALineOfCredit]: VideoWithFootnoteAdNameAttributes,
    [AdName.faqVideoWhichProductIsBetter]: VideoWithFootnoteAdNameAttributes,
    [AdName.uccBalanceTransferTeaserPreExpirationAug2025]: NonCycledUpgradeCardAdNameAttributes, // always show because it has high CTR (as of Nov 2025)
    [AdName.uccBalanceTransferTeaserPostExpirationAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.balanceDetailsBeardSep2025]: NonCycledUpgradeCardAdNameAttributes, // always show because it has high CTR (as of Nov 2025) and Rizvi wanted it
    [AdName.creditCardBalanceTransferAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.personalLoanRefiAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.genericAvenCashAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.genericMoapAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.genericMoapVideoInterstitialAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.dryrunHelocRefiNov2025]: NonCycledUpgradeCardAdNameAttributes,
    [AdName.dryrunMoapAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.homeEquityFocusDryrunMoapAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.postFlexCashOutDryrunMoapSep2025]: NonCycledUpgradeCardAdNameAttributes,
    [AdName.flexToHomeActivityDryrunMoapFeb2026]: CycledUpgradeCardAdNameAttributes,
    [AdName.flexToHomePlTransferDryrunMoapMar2026]: CycledUpgradeCardAdNameAttributes,
    [AdName.mortgageRefiAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.signNowMoapAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.getMoneyAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.getMoneyWithOneYearOfStarbucksOct2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.genericStarbucksMoapAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.uccMoapStarbucksAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.uccMoapStarbucksFiftyDollarCreditAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.uccFlexLargePurchaseAdviceAug2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.helocRefiGuaranteedBeatOct2025]: CycledUpgradeCardAdNameAttributes,
    [AdName.uccToHomeGuaranteedAprBeatJan2026]: NonCycledUpgradeCardAdNameAttributes,
    [AdName.uccToHomeActivityCardCarouselJan2026]: NonCycledUpgradeCardAdNameAttributes,
    [AdName.uccToHomeCashBackSideBySideAug2026]: CycledUpgradeCardAdNameAttributes,
    [AdName.boostNetWorthDec2025]: NonCycledUpgradeCardAdNameAttributes,
    [AdName.flexToHomeInterestSavedUpgradeFeb2026]: CycledUpgradeCardAdNameAttributes,
    [AdName.advisorGenericDepositFeb2026]: NonCycledUpgradeCardAdNameAttributes,
    [AdName.homeDeniedDepositMar2026]: NonCycledUpgradeCardAdNameAttributes,
    [AdName.rewardsBtUpsellBalanceDetailsBeardSep2026]: NonCycledUpgradeCardAdNameAttributes,
    [AdName.rewardsBtUpsellInAppAug2026]: NonCycledUpgradeCardAdNameAttributes,
    [AdName.rewardsDepositBundleUpsellSep2026]: CycledUpgradeCardAdNameAttributes,
    // the satisfies clause is necessary for the record to be exhaustive: it cannot be declared as a record though
    //  because the type AdNameAttributes does not extend e.g. { hasVideoFootnotes: true }, so we simply allow
    //  the compiler to infer the value type; otherwise, VideoAdName = never
};
var AdTag;
(function (AdTag) {
    AdTag["Moap"] = "Moap";
    AdTag["AvenCash"] = "AvenCash";
    AdTag["Ucc"] = "Ucc";
    AdTag["Advisor"] = "Advisor";
    AdTag["Auto"] = "Auto";
    AdTag["Mortgage"] = "Mortgage";
    AdTag["Deposit"] = "Deposit";
    AdTag["Aryan"] = "Aryan";
    AdTag["Burke"] = "Burke";
    AdTag["BalanceTransfer"] = "BalanceTransfer";
    AdTag["CashOut"] = "CashOut";
    AdTag["Rewards"] = "Rewards";
    AdTag["PersonalLoan"] = "PersonalLoan";
    AdTag["MortgageRefi"] = "MortgageRefi";
    AdTag["Starbucks"] = "Starbucks";
    AdTag["Generic"] = "Generic";
    AdTag["Flex"] = "Flex";
    AdTag["HelocRefi"] = "HelocRefi";
})(AdTag || (exports.AdTag = AdTag = {}));
var AdPlacement;
(function (AdPlacement) {
    /**
     * The FAQ videos on the support landing page
     */
    AdPlacement["supportLandingFaqVideos"] = "supportLandingFaqVideos";
    /**
     * The "home equity FAQs" feed card unit in Aven My
     */
    AdPlacement["AvenMyHomeEquityHelpCenter"] = "AvenMyHomeEquityHelpCenter";
    /**
     * The main feed in Advisor
     */
    AdPlacement["todayFeed"] = "todayFeed";
    /**
     * After the user has claimed Starbucks, in the same modal as the coffee confirmation. Corresponds
     * to POST_REDEEM in FreeCoffeeUpsellFlowStatus
     */
    AdPlacement["starbucksUpsell"] = "starbucksUpsell";
    /**
     * An interstitial after the user clicks the "Buy me a coffee". Corresponds to INTERSTITIAL in
     * FreeCoffeeUpsellFlowStatus
     */
    AdPlacement["starbucksPreClaimInterstitial"] = "starbucksPreClaimInterstitial";
    /**
     * A unit that comes after the preClaimInterstitial but before coffee is actually claimed. Corresponds
     * to PRE_CLAIM_POST_INTERSTITIAL in FreeCoffeeUpsellFlowStatus
     */
    AdPlacement["advisorStarbucksPostPreClaimInterstitial"] = "starbucksPostPreClaimInterstitial";
    /**
     * Modal that shows after the user clicks a CTA telling them they'll get a year of Starbucks
     * in Advisor
     */
    AdPlacement["oneYearOfStarbucksUpsell"] = "oneYearOfStarbucksUpsell";
    /**
     * Large purchase advice ad in Advisor
     */
    AdPlacement["advisorLargePurchaseAdvice"] = "advisorLargePurchaseAdvice";
    /**
     * Boost net worth upsell in Advisor
     */
    AdPlacement["advisorBoostNetWorth"] = "advisorBoostNetWorth";
    /**
     * Deposit account ad on the Advisor V2 overview tab
     */
    AdPlacement["advisorDepositAd"] = "advisorDepositAd";
    /**
     * Mortgage refinance ad on the Advisor V2 overview tab
     */
    AdPlacement["advisorMortgageRefi"] = "advisorMortgageRefi";
    /**
     * Placement above the balance card, so literally the highest slot on the activity screen.
     */
    AdPlacement["avenMyActivityAboveBalanceCard"] = "avenMyActivityAboveBalanceCard";
    /**
     * Placement that creates a "beard" for the balance card (i.e. immediately below the balance card).
     */
    AdPlacement["avenMyActivityBalanceDetailsBeard"] = "avenMyActivityBalanceDetailsBeard";
    /**
     * The placement just below quick actions on the Aven My Activity tab. This is the most
     * prime real estate because it's usually above the fold (depending on screen size).
     */
    AdPlacement["avenMyActivityBelowQuickActions"] = "avenMyActivityBelowQuickActions";
    /**
     * Upgrade slot 1: Rotates through units that scale with views (getMoney, dryrunMoap).
     * Placed below quick actions, shows one ad at a time.
     */
    AdPlacement["avenMyActivityUpgradeSlot1ViewScaling"] = "avenMyActivityUpgradeSlot1ViewScaling";
    /**
     * Upgrade slot 2: Rotates through units that don't scale with views (creditCardBalanceTransfer,
     * personalLoanRefi, genericAvenCash). Placed below slot 1, shows one ad at a time.
     */
    AdPlacement["avenMyActivityUpgradeSlot2Targeted"] = "avenMyActivityUpgradeSlot2Targeted";
    /**
     * The placement just above the PIF card on Aven My activity screen.
     */
    AdPlacement["avenMyActivityAbovePayItForward"] = "avenMyActivityAbovePayItForward";
    /**
     * The placement right below the "What is Due" / "Nothing Due" card on the Aven My Activity tab.
     */
    AdPlacement["avenMyActivityBelowWhatIsDue"] = "avenMyActivityBelowWhatIsDue";
    /**
     * The placement at the very bottom of the screen on the Aven My Activity tab.
     */
    AdPlacement["avenMyActivityBottom"] = "avenMyActivityBottom";
    /**
     * A carousel of cards to swipe through the quick actions on the Aven My Activity tab.
     */
    AdPlacement["avenMyActivityCardCarousel"] = "avenMyActivityCardCarousel";
    /**
     * This place is the screen immediately after cash out success.
     */
    AdPlacement["avenMyPostCashOut"] = "avenMyPostCashOut";
})(AdPlacement || (exports.AdPlacement = AdPlacement = {}));
exports.AdvisorEmbeddedAdPlacements = [
    AdPlacement.todayFeed,
    AdPlacement.starbucksUpsell,
    AdPlacement.oneYearOfStarbucksUpsell,
    AdPlacement.starbucksPreClaimInterstitial,
    AdPlacement.advisorStarbucksPostPreClaimInterstitial,
    AdPlacement.advisorLargePurchaseAdvice,
    AdPlacement.advisorBoostNetWorth,
    AdPlacement.advisorDepositAd,
    AdPlacement.advisorMortgageRefi,
];
